import React from "react";
// Footer

// Mui
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";

// Svg
import CopyRight from "../../assets/svg/copyRight";
import { Link } from "react-router-dom";

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  return (
    <Stack
      direction={"row"}
      pt={"13px"}
      pb={"13px"}
      gap={"4px"}
      justifyContent={"center"}
      alignItems={"center"}
    >
      <Typography
        variant="body2"
        display={"flex"}
        gap={"2px"}
        fontSize={"10px"}
        alignItems={"center"}
      >
        Powered by
        <Link to="https://voltreum.com" target="_blank">
          <Typography
            variant="body2"
            color="#1064ED"
            fontSize={"10px"}
            fontWeight={700}
          >
            Voltreum.
          </Typography>
        </Link>
      </Typography>

      <Stack direction={"row"} gap={"2px"} alignItems={"center"}>
        <CopyRight />
        <Typography variant="body2" fontSize={"10px"}>
          All Rights Reserved {currentYear}
        </Typography>
      </Stack>
    </Stack>
  );
};

export default Footer;
